module.exports = __webpack_public_path__ + "static/img/wzmacniacz8.da0bea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/wzmacniacz8.png
// module id = wiLY
// module chunks = 1